// extracted by mini-css-extract-plugin
export default {"dynamic_text":"DynamicText_dynamic_text__+e49P","appear":"DynamicText_appear__nKwik"};